import { Color } from "ogl";

export function createGradient(
  funcName: string,
  colors: [position: number, color: string][]
) {
  let shaderCode = `
    vec3 ${funcName}(float x) {
      vec3 color = vec3(1.0);
      float prevPos = 0.0;
      vec3 prevCol = ${hexToVec3(colors[0][1])};
  `;

  for (let i = 1; i < colors.length; i++) {
    shaderCode += `
      if (x < ${colors[i][0].toFixed(6)}) {
        float alpha = (x - prevPos) / (${colors[i][0].toFixed(6)} - prevPos);
        color = mix(prevCol, ${hexToVec3(colors[i][1])}, alpha);
        return color;
      }
      prevPos = ${colors[i][0].toFixed(6)};
      prevCol = ${hexToVec3(colors[i][1])};
    `;
  }

  // If x is beyond the last stop, it uses the last color
  shaderCode += `
      color = prevCol;
      return color;
    }
  `;

  return shaderCode;
}

function hexToVec3(hex: string) {
  const color = new Color(hex);
  return `vec3(${color.r}, ${color.g}, ${color.b})`;
}
